import { HelpContent } from '../../UI-Lib/Help-Tooltip';

export const TAX_AUTHORITY_HELP: HelpContent[] = [
    {
        helpContentId: 'tax-authority.certain-exemptions-disabled',
        tooltipText: 'Select "Certain Exemptions" to enable this feature.'
    },
    {
        helpContentId: 'tax-authority.honor-exemptions-on-alternate-av-disabled',
        tooltipText: 'Taxable Assessment must be set to "Lower of Total AV and Alternate AV" to enable this feature.'
    }
];
